"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var myAccountMiniContainerStyles = makeStyles_1.default(function (theme) { return ({
    container: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        zIndex: 2,
    },
    buttonWrapper: {
        display: 'flex',
        textAlign: 'left',
        fontSize: theme.typography.fontMD,
        backgroundColor: theme.palette.common.white,
        maxWidth: '96%',
    },
}); }, { name: 'Checkout4_MyAccountMiniContainer' });
exports.default = myAccountMiniContainerStyles;
